import { Injectable } from '@angular/core';
import { TemplateInterface } from 'models/template.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  public _templates: Array<TemplateInterface>;
  public working_spinner: boolean = false;

  constructor(private http: HttpClient) {
    this._templates = [];
  }

  public async saveTemplateHTML(template: TemplateInterface) {
    const GET_TEMPLATES_URL: string = `https://us-central1-relayclients.cloudfunctions.net/updateTemplate`;
  }

  public async getTemplates() {
    
    const GET_TEMPLATES_URL: string = `https://us-central1-relayclients.cloudfunctions.net/getTemplates`;
    this.working_spinner = true;
    console.log(`Querying API for templates ${GET_TEMPLATES_URL}`);
    const templatesResponse: any = await this.http.get(GET_TEMPLATES_URL).toPromise();
    
    for (const key in templatesResponse) {
      if (templatesResponse.hasOwnProperty(key)) {
        const template = templatesResponse[key];
        this._templates.push(template);
      }
    }
    
    console.log(this._templates);
    
    
    this.working_spinner = false;
  }
}
